import { render, staticRenderFns } from "./OrderCourseCard.vue?vue&type=template&id=5c97f03c&scoped=true&"
import script from "./OrderCourseCard.vue?vue&type=script&lang=js&"
export * from "./OrderCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderCourseCard.vue?vue&type=style&index=0&id=5c97f03c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c97f03c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
